import actions from '@/store/blogs/actions';

const blogsModule = {
  state: () => ({
    categoriesList: [],
    isLoading: false,
    isCategoriesLoaded: false,
    error: null,
    articlesList: [],
    articlesTotal: 0,
    isArticlesLoaded: false,
    isCurrentArticleLoaded: false,
    currentArticle: {},
    isArticleBannerLoaded: false,
    articleBanner: [],
    articleBottomBanner: [],
    allBannerAds: {},
  }),
  mutations: {
    GET_CATEGORIES_START(state) {
      state.isLoading = true;
      state.error = null;
      state.isCategoriesLoaded = false;
    },
    GET_CATEGORIES_SUCCESS(state, payload) {
      state.categoriesList = payload;
      state.isLoading = false;
      state.isCategoriesLoaded = true;
      state.error = null;
    },
    GET_CATEGORIES_FAILURE(state, data) {
      state.isLoading = false;
      state.isCategoriesLoaded = false;
      state.error = data;
    },
    GET_ARTICLES_START(state) {
      state.isLoading = true;
      state.error = null;
      state.isArticlesLoaded = false;
    },
    GET_ARTICLES_SUCCESS(state, payload) {
      state.articlesList = payload.data;
      state.articlesTotal = payload.total;
      state.isLoading = false;
      state.isArticlesLoaded = true;
      state.error = null;
    },
    GET_ARTICLES_FAILURE(state, data) {
      state.isLoading = false;
      state.isArticlesLoaded = false;
      state.error = data;
    },
    GET_ARTICLE_START(state) {
      state.isLoading = true;
      state.error = null;
      state.isCurrentArticleLoaded = false;
    },
    GET_ARTICLE_SUCCESS(state, payload) {
      state.currentArticle = payload;
      state.isCurrentArticleLoaded = true;
      state.isLoading = false;
      state.error = null;
    },
    GET_ARTICLE_FAILURE(state, data) {
      state.isLoading = false;
      state.isCurrentArticleLoaded = false;
      state.error = data;
    },
    SUBMIT_ARTICLE_START(state) {
      state.isLoading = true;
    },
    SUBMIT_ARTICLE_FAILURE(state) {
      state.isLoading = false;
    },
    GET_ARTICLE_BANNER_START(state) {
      state.isArticleBannerLoaded = false;
      state.isLoading = true;
      state.error = null;
    },
    GET_ARTICLE_BANNER_SUCCESS(state, payload) {
      state.isArticleBannerLoaded = true;
      state.isLoading = false;
      const banners = payload || [];
      const bottomBanners = ['bottom_articles_list', 'bottom_product', 'bottom_custom_ads', 'bottom_social_network'];
      state.articleBanner = banners.filter(({ type }) => !bottomBanners.includes(type));
      state.articleBottomBanner = banners.filter(({ type }) => bottomBanners.includes(type));
    },
    GET_ARTICLE_BANNER_FAILURE(state, data) {
      state.isArticleBannerLoaded = false;
      state.articleBanner = {};
      state.isLoading = false;
      state.error = data;
    },
    SUBMIT_ARTICLE_BANNER_START(state) {
      state.isLoading = true;
    },
    SUBMIT_ARTICLE_BANNER_FAILURE(state) {
      state.isLoading = false;
    },
    GET_ALL_BANNER_ADS_START(state) {
      state.allBannerAds = {};
    },
    GET_ALL_BANNER_ADS_SUCCESS(state, data) {
      state.allBannerAds = data;
    },
    GET_ALL_BANNER_ADS_FAILURE(state) {
      state.allBannerAds = {};
    },
  },
  actions,
  namespaced: true,
};

export default blogsModule;
